import { LoadingSpinner } from "./loading-spinner";

interface LoadingStateProps {
  label?: string;
  className?: string;
  size?: "sm" | "md" | "lg";
  variant?: "default" | "glass";
}

export function LoadingState({
  label = "Loading...",
  className = "",
  size = "md",
  variant = "default",
}: LoadingStateProps) {
  return (
    <div
      role="status"
      aria-label={label}
      className={`flex items-center justify-center gap-2 ${
        variant === "glass"
          ? "bg-white/10 backdrop-blur-md rounded-lg p-4 shadow-lg border border-white/20"
          : ""
      } ${className}`}
    >
      <LoadingSpinner size={size} />
      {variant === "glass" && <span className="text-white/90">{label}</span>}
      {variant === "default" && <span className="sr-only">{label}</span>}
    </div>
  );
}
